import { createUseStyles } from 'react-jss';

export default createUseStyles({
  questionnaire: {
    marginBottom: '32px',
  },

  questionsContainer: {
    marginBottom: '16px',
  },

  addQuestionButton: {
    marginTop: '32px',
    width: '252px',
    height: '56px',
    '@media(max-width: 900px)': {
      width: '100%',
    },
  },

  listItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '16px',
    height: '64px',
    borderRadius: ['8px', '!important'],
    border: ['none', '!important'],
    '&:hover': {
      boxShadow: '4px 4px 4px 4px rgba(16, 33, 49, 0.04)',
    },
  },

  rightPart: {
    display: 'flex',
    alignItems: 'center',
  },

  questionName: {
    fontWeight: 'normal',
    fontSize: '16px',
    color: '#102131',
  },

  questionType: {
    fontWeight: 'normal',
    fontSize: '12px',
    textAlign: 'right',
    color: '#B2B9C0',
    marginRight: '24px',
  },

  modal: {
    width: '560px',
    maxWidth: '640px',
    '@media(max-width: 900px)': {
      width: '100%',
      margin: 0
    }
  },
});
